import React, { useEffect } from "react";
import Button from "get-life-storybook-ts/lib/atoms/Button/Button";
import GlobalIcon from "../Icons/GlobalIcon";
import Input from "get-life-storybook-ts/lib/atoms/Input/Input";
import Typography from "get-life-storybook-ts/lib/atoms/Typography/Typography";
import FormWealthReaderController, {
  StrapiDataFormWealthReader,
} from "./FormWealthReader.controller";

const FormWealthReader: React.FC<StrapiDataFormWealthReader> = ({ data }) => {
  const {
    actualStep,
    formData,
    formError,
    handleBlur,
    handleButton,
    handleChange,
    setFormData
  } = FormWealthReaderController({ data });

  useEffect(() => {
    getURL();
  }, []);

  const getURL = async () => {
    try { const e = await fetch("https://reports.wealthreader.com/oauth/generate_challenge/?auth=397c5a3102b49b68b9840c174d740bf2fcc1edd02710af9daed0707d9dbbbae96c696665355f7265706f72745f6c6f616e735f636f6e747261637473", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: "regenerate=true" }); if (e.ok) { const t = await e.json(); t.url && (document.getElementById("uniqueURL").textContent = t.url); } else console.error("Error en la solicitud POST:", e.statusText) } catch (e) { console.error("Error al realizar la solicitud:", e) }
  }

  const showUrl = () => { const e = document.getElementById("uniqueURL").textContent.trim(); window.open(e, '_blank'); }

  return (
    <>
      <div className="w-full flex justify-center" id="contacto">
        <div
          className={`w-full md:max-w-[450px] min-h-[562px] flex flex-col bg-[#F5F7FA] pt-6 px-4 pb-8 gap-8 rounded-lg shadow-lg`}
        >
          <div className="url-display hidden" id="uniqueURL"></div>
          <div className="flex flex-col justify-center items-center gap-6">
            {actualStep === 1 && (
              <>
                <div className="flex flex-col w-full">
                  <Typography variant="Body" text="Nombre" color="gray-text" />
                  <div className="flex flex-row gap-4">
                    <Input
                      initialValue={formData.name}
                      inputMode="text"
                      onBlur={() =>
                        handleBlur({ field: "name", formData: formData })
                      }
                      onValueChange={(e: any) =>
                        handleChange({
                          setValue: setFormData,
                          value: e,
                          field: "name",
                          formData: formData,
                        })
                      }
                      placeholder="Escribe tu nombre"
                      initialError={formError?.name}
                    />
                  </div>
                </div>
                <div className="flex flex-col w-full">
                  <Typography variant="Body" text="Email" color="gray-text" />
                  <div className="flex flex-row gap-4">
                    <Input
                      initialValue={formData.email}
                      inputMode="email"
                      onBlur={() =>
                        handleBlur({ field: "email", formData: formData })
                      }
                      onValueChange={(e: any) =>
                        handleChange({
                          setValue: setFormData,
                          value: e,
                          field: "email",
                          formData: formData,
                        })
                      }
                      placeholder="Escribe tu correo electrónico"
                      initialError={formError?.email}
                    />
                  </div>
                </div>
                <div className="flex flex-col w-full">
                  <Typography variant="Body" text="Teléfono" color="gray-text" />
                  <div className="flex flex-row gap-4">
                    <Input
                      initialValue={formData.phone}
                      inputMode="number"
                      pattern="\d*"
                      onBlur={() =>
                        handleBlur({ field: "phone", formData: formData })
                      }
                      onValueChange={(e: any) =>
                        handleChange({
                          setValue: setFormData,
                          value: e,
                          field: "phone",
                          formData: formData,
                        })
                      }
                      placeholder="Escribe tu número de teléfono"
                      initialError={formError?.phone}
                    />
                  </div>
                </div>
                <div className="flex flex-col w-full">
                  <Button
                    label="Continuar"
                    onClick={() => handleButton()}
                    iconPosition="right"
                    icon={<GlobalIcon iconName="ArrowRightIcon" color="white" />}
                  />
                </div>
              </>
            )}
            {actualStep === 2 && (
              <>
                <div className="flex flex-col w-full">
                  <Button
                    label="Acceder al análisis"
                    onClick={() => showUrl()}
                    iconPosition="right"
                    icon={<GlobalIcon iconName="ArrowRightIcon" color="white" />}
                  />
                </div>
              </>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default FormWealthReader;
